import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import { getDobDate } from "../../common/DisplayDate";
import getPersonName from "../../common/Name";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";
import getSsn from "../../common/Ssn";

class AKAsDetails extends Component {
  state = {
    rows: [],
    savedResultID: "",
    internalID: "",
  };

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  loadData = (props) => {
    const rows = [];
    let recCount = 0;
    if (props.reportData !== undefined) {
      const identities = _.get(
        props.reportData,
        "personReport.compReportResponse[0].individual[0].AKAs[0].identity"
      );
      if (identities) {
        _.forEach(identities, (record, index) => {
          const SSN = getSsn(_.get(record, "SSNInfo[0].SSN[0]._", ""), props);
          const DOB = getDobDate(_.get(record, "DOB[0]"), {
            userAccount: this.props.userAccount,
          });
          rows.push(
            <Table.Row key={`rep_liens_row_3_${index}`}>
              <Table.Cell className="text-bold">Name:</Table.Cell>
              <Table.Cell>
                {getPersonName(
                  _.get(record, "name[0].first[0]._", ""),
                  "",
                  _.get(record, "name[0].last[0]._", ""),
                  this.props
                )}
              </Table.Cell>

              <Table.Cell className="text-bold">DOB:</Table.Cell>
              <Table.Cell> {DOB} </Table.Cell>

              <Table.Cell className="text-bold">SSN:</Table.Cell>
              <Table.Cell> {SSN} </Table.Cell>
            </Table.Row>
          );
        });
        recCount = rows.length;
      } else {
        rows.push(
          <Table.Row key={`no_recs_row`}>
            <Table.Cell colSpan={2}>No Records found</Table.Cell>
          </Table.Row>
        );
      }
    }
    this.setState({ rows });
    props.updateItemCountBySection(props.sectionName, recCount);
  };

  render() {
    return (
      <SimpleAccordionContent
        {...this.props}
        name={"AKAs"}
        rows={this.state.rows}
        additionalClasses={"table-custom-strip"}
      />
    );
  }
}

export default AKAsDetails;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/AKAsDetails.js